import { useRef as x, useCallback as w, useMemo as L, cloneElement as O } from "react";
import { StyleSheet as M, Platform as b } from "react-native-web";
function y(o) {
  return o.charAt(0).toUpperCase() + o.slice(1);
}
function T(o, l = {}, h = {}) {
  const v = x(l);
  v.current = l;
  const u = w((r) => r.toLowerCase() === "state", []), d = w((r, c) => {
    const a = [[null, c[r]]], s = Object.entries(o).sort((e, n) => e[0].localeCompare(n[0]));
    for (const [e, n] of s)
      if (s.length === 1)
        for (const t of n) {
          const f = `${r}${y(e)}${t}`, m = c[f];
          if (!m) continue;
          const i = (p) => (
            // Test whether the current variant is the same as the value
            // or if the current variant is state and the pressable state matches the value
            v.current[e] === t || (u(e) ? p?.[t.toLowerCase()] ?? !1 : !1)
          );
          a.push([i, m]);
        }
      else {
        if (u(e)) continue;
        for (const t of n)
          for (const [f, m] of s)
            if (e !== f)
              for (const i of m) {
                const p = `${r}${y(e)}${t}${y(f)}${i}`, $ = c[p];
                if (!$) continue;
                const k = (S) => (
                  // Test whether the current variant is the same as the value
                  // or if the current variant is state and the pressable state matches the value
                  (v.current[e] === t || (u(e) ? S?.[t.toLowerCase()] ?? !1 : !1)) && (v.current[f] === i || (u(f) ? S?.[i.toLowerCase()] ?? !1 : !1))
                );
                a.push([k, $]);
              }
      }
    return a;
  }, [o, u]), C = w((r) => {
    const c = /* @__PURE__ */ new Map(), a = {};
    for (const s in r)
      a[s] = (e) => {
        let n = c.get(s);
        return n || (n = d(s, r), c.set(s, n)), n.filter(([t]) => t === null || t?.(e)).map(([, t]) => t);
      };
    return a;
  }, [d]);
  return {
    vstyles: L(() => C(h), [h, C])
  };
}
function V(o, l) {
  return o ? O(o, M.flatten(l)) : null;
}
function g() {
  switch (b.OS) {
    case "ios":
    case "android":
      return !0;
    case "macos":
    case "windows":
      return !1;
    case "web":
      return navigator.maxTouchPoints > 0 || "ontouchstart" in window;
    default:
      return !1;
  }
}
function j() {
  return b.OS !== "web";
}
export {
  V as createIcon,
  j as isNative,
  g as isTouch,
  T as useVariants
};
